


export const A_HttpServerFeatures = {
    onBeforeRequest: '_A_HTTPServer_onBeforeRequest',
    onRequest: '_A_HTTPServer_onRequest',
    onAfterRequest: '_A_HTTPServer_onAfterRequest',
} as const

